import EventEmitter from "./eventEmitter";

export default class Sizes extends EventEmitter {

    constructor() {

        super()

        // SETUP
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        // RESIZE
        window.addEventListener('resize', () => {
            this.width = window.innerWidth
            this.height = window.innerHeight
            this.pixelRatio = Math.min(window.devicePixelRatio, 2)

            // triggera event emitter
            this.trigger('resize')
        })
    }
}